import { render, staticRenderFns } from "./VersionDownloadModal.vue?vue&type=template&id=3c1dc304"
import script from "./VersionDownloadModal.vue?vue&type=script&lang=js"
export * from "./VersionDownloadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports